import { useEffect } from 'react';
import { TEALEAF_SESSION_ID_COOKIE_NAME } from '../thunks/tealeafThunks';

const useSetTltsId = (location, cookies) => {
  const cookieDomain = {
    domain: '.americanexpress.com',
  };

  useEffect(() => {
    const queryTealeafId = location?.query?.[TEALEAF_SESSION_ID_COOKIE_NAME];
    if (queryTealeafId) {
      cookies.set(TEALEAF_SESSION_ID_COOKIE_NAME, queryTealeafId, cookieDomain);
    }
  }, []);
};

export default useSetTltsId;
